<template>
  <div id="ComponentList" class="page">
    <file-page-title />
    <div class="search-line">
      <div>
        <el-button type="primary" @click="toCreatePlan">新建</el-button>
      </div>
      <div class="btn-right">
        <span>共 {{ dataTotal }} 个内容</span>
        <el-button
            type="text"
            icon="el-icon-refresh-right"
            title="刷新"
            class="refresh-btn"
            @click.stop="handleRefresh"
        />
      </div>
    </div>
    <gjw-dimensions @height-changed="onBoxHeightChanged">
      <div class="content-container">
        <div class="fix-flex-table">
          <gjw-table
              ref="listTable"
              v-loading="tableLoading"
              :columns="tableColumns"
              :list-data="tableData"
              :has-page="false"
              :max-height="tableHeight"
          >
            <template #nameSlot="{ row, index }">
              <edit-input
                  v-if="modifyIndex === index && modifyCol === 'name'"
                  @click.stop.native
                  ref="editName"
                  :maxlength="30"
                  :init-value="tempRow.name"
                  @edit-confirm="(value)=>modifyName(row, value)"
                  @edit-cancel="resetModify"
              />
              <span v-else class="table-name">
                  <img class="file-img" src="../../../assets/file/plan.png" style="margin-right: 6px;" alt="" />
                  <span class="name-click" @click.stop="toView(row)">{{ row.name }}</span>
                </span>
            </template>
            <template #fileSlot="{ row }">
              <div>
                <span>{{row.fileCount || 0}}</span>
                <el-button type="text" class="mg-lt-md" @click.stop="toViewDetail(row)">详情<i class="el-icon-arrow-right"/></el-button>
              </div>
            </template>
            <template #operateSlot="{ row , index }">
              <div @click.stop @dbclick.stop>
                <el-button type="text" @click.stop.native="toPublish(row)">交付</el-button>
                <el-button type="text" @click.stop="toShare(row)">分享</el-button>
                <el-dropdown>
                    <span class="el-dropdown-link">
                      <i class="el-icon-more ft-theme"></i>
                    </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.stop.native="renamePlan(row, index, 'name')"><span>重命名</span></el-dropdown-item>
                    <el-dropdown-item class="delete-button" @click.stop.native="deletePlan(row, index)"><span>删除</span></el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </gjw-table>
        </div>
      </div>
    </gjw-dimensions>
    <!-- 分享合模方案 -->
    <model-share-dialog ref="ModelShareDialog" share-type="FEDERATED_PLAN" @share-link-opened='shareTrack' />
    <!-- 新建编辑文件 -->
    <create-edit-plan ref="CreateEditPlanDialog" />
    <!-- 方案详情 -->
    <federation-plan-detail :space-id="spaceId" ref="federationPlanDetail" @close-draw="getList" />
    <!-- 发布合模方案 -->
    <federation-publish-dialog ref="federationPublishDialog" @publish-error-detail="toViewDetail" />
  </div>
</template>

<script>
import FilePageTitle from '../components/FilePageTitle.vue'
import CreateEditPlan from '../components/CreateEditPlan.vue'
import FederationPlanDetail from '../components/FederationPlanDetail.vue'
import EditInput from '@/components/business/EditInput.vue'
import { RegSymbol } from '@/core/RegExp'
import { federationErrorCodeMap } from '../errorCodeMap'
import GjwDimensions from '@/components/lib/GjwDimensions.vue'
import openUrlMixin from '@/mixins/openUrlMixin'
import FederationPublishDialog from '../components/FederationPublishDialog.vue'
import ModelShareDialog from '@/views/file/components/ModelShareDialog.vue'

export default {
  name: 'FederationPlanList',
  components: { ModelShareDialog, GjwDimensions, FilePageTitle, CreateEditPlan, EditInput, FederationPlanDetail, FederationPublishDialog },
  mixins: [openUrlMixin],
  data() {
    return {
      spaceId: this.$route.params.spaceId,
      dataTotal: 0,
      tableHeight: 0,
      tableLoading: false,
      tableData: [],
      modifyIndex: -1, // 当前要修改的行序
      modifyCol: '', // 当前要修改的col
      tempRow: {}, // 备份要修改的row
    }
  },
  computed: {
    tableColumns() {
      return [
        {
          type: 'slot',
          slotName: 'nameSlot',
          label: '名称',
          prop: 'name',
          minWidth: '200px',
        },
        // 轻量化模型
        {
          type: 'slot',
          slotName: 'fileSlot',
          label: '合模文件',
          showOverflowTooltip: false,
          prop: 'fileCount',
          width: '100px',
        },
        {
          label: '创建人',
          prop: 'creatorName',
          minWidth: '100px',
        },
        {
          label: '创建时间',
          prop: 'createTime',
          width: '160px',
          formatter: (row, col, cell) => {
            return this.$fmtTime(cell, 'YYYY-MM-DD HH:mm:ss')
          },
        },
        {
          type: 'slot',
          slotName: 'operateSlot',
          label: '操作',
          width: '120px'
        },
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    onBoxHeightChanged({ newValue }) {
      this.tableHeight = newValue
    },
    toCreatePlan() {
      this.$refs.CreateEditPlanDialog?.openDialog()
    },
    async handleRefresh() {
      await this.getList()
      this.$message.success('数据已刷新')
    },
    async getList() {
      // 更新数据时，取消编辑状态
      this.resetModify()
      this.tableLoading = true
      this.$api.file.federationPlanList(this.spaceId).then((data) => {
        if (data) {
          this.tableData = data.list || []
          this.dataTotal = data.totalCount || 0
        }
      }).catch((err) => {
        this.$matchError(err.code, {}, '获取合模方案列表失败')
      }).finally(() => {
        this.tableLoading = false
      })
    },
    // 修改之后重置
    resetModify() {
      this.modifyCol = ''
      this.modifyIndex = -1
      this.tempRow = {}
    },
    // 修改名称
    async modifyName(row, value) {
      if (row.name === value) {
        this.resetModify()
        return
      }
      if (!value && value !== 0) {
        this.$message.error('请输入名称')
        return
      }
      if (RegSymbol.test(value)) {
        this.$message.error('名称中有禁止的特殊符号')
        return
      }
      await this.$api.file.renameFederationPlan(this.spaceId, row.id, { name: value }).then((res) => {
        if (res === true) {
          this.$message.success(`修改成功`)
          this.resetModify()
          this.getList()
        }
        this.$tracks({
          event: 'modifyFederatedPlan',
          params: {
            g_c_space_id: this.spaceId,
            g_c_federated_plan_id: row.id,
          }
        })
      }).catch((err) => {
        const errors = {
          ...federationErrorCodeMap,
          'duplicate.name.error': '存在重名方案，请修改',
          'name.length.exceed': '名称长度超出限制',
          'name.contain.special.characters': '名称包含特殊字符',
        }
        this.$matchError(err.code, errors, '修改失败')
      })
    },
    // 查看模型
    toView(row) {
      if (!row.fileCount) {
        this.$message.warning('该方案下无可查看模型')
        return
      }
      this.$tracks({
        event: '3DViewFederatedPlan',
        params: {
          g_c_space_id: this.spaceId,
          g_c_federated_plan_id: row.id,
        }
      })
      const view = this.$router.resolve({
        name: 'FederationPlanView',
        params: {
          spaceId: this.spaceId,
        },
        query: {
          id: row.id,
          title: row.name
        },
      })
      const viewUrl = `${process.env.VUE_APP_PROJECT_HOST}${view.href}`
      this.openUrl(viewUrl, true, '_blank')
    },
    // 查看方案详情
    toViewDetail(row) {
      this.$refs.federationPlanDetail?.openDrawer(row)
      this.$tracks({
        event: 'viewFederatedPlanDetail',
        params: {
          g_c_space_id: this.spaceId,
          g_c_federated_plan_id: row.id,
        }
      })
    },
    // 交付
    async toPublish(row) {
      this.$refs.federationPublishDialog?.openDialog(row)
    },
    // 去分享
    toShare(row) {
      this.$refs.ModelShareDialog?.openDialog(row)
    },
    shareTrack(shareModelFileInfo) {
      this.$tracks({
        event: 'shareFederatedPlan',
        params: {
          g_c_space_id: this.spaceId,
          g_c_federated_plan_id: shareModelFileInfo.id,
        }
      })
    },
    renamePlan(row, index, colName) {
      this.modifyCol = colName
      this.modifyIndex = index
      this.tempRow = { ...row }
      this.$nextTick(() => {
        switch (colName) {
          case 'name':
            this.$refs.editName.toFocus()
            break
        }
      })
    },
    deletePlan(row, index) {
      const tooltipText = `删除后<span style="color: red;">无法恢复</span>，分享链接将失效，是否确定删除${row.name}？`
      this.$confirm(tooltipText, {
        type: 'warning',
        dangerouslyUseHTMLString: true,
        confirmButtonClass: 'user-confirm',
        confirmButtonText: '确定删除',
      }).then(() => {
        this.$api.file.deleteFederationPlan(this.spaceId, row.id).then(() => {
          this.$message.success(`删除成功`)
          this.$tracks({
            event: 'deleteFederatedPlan',
            params: { g_c_space_id: this.spaceId, g_c_federated_plan_id: row.id }
          })
          // 将数据在表格中移除
          this.tableData.splice(index, 1)
        }).catch((err) => {
          this.$matchError(err.code, federationErrorCodeMap, '删除失败')
        })
      }).catch()
    },
  },
}
</script>

<style lang="less" scoped>
.search-line {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
}
.content-container{
  margin: 0 16px;
  display: flex;
  flex-direction: column;
  position: relative;
  height: calc(100% - 108px);
}
.file-img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
.name-click{
  cursor: pointer;
  color: @theme-color;
}
.delete-button{
  color: red;
  &:hover{
    color: #fff;
    background: red;
  }
}

</style>
